import React from 'react';
import moment from 'moment';
import ReactDatePicker from 'react-datepicker';
import { TIMEZONE } from '../../../services/ui/date';
const setLocalZone = (date) => {
    const dateWithoutZone = moment
        .tz(date, TIMEZONE)
        .format('YYYY-MM-DDTHH:mm:ss.SSS');
    const localZone = moment(dateWithoutZone).format('Z');
    const dateWithLocalZone = [dateWithoutZone, localZone].join('');
    return new Date(dateWithLocalZone);
};
const setRemoteZone = (date) => {
    const dateWithoutZone = moment(date).format('YYYY-MM-DDTHH:mm:ss.SSS');
    const otherZone = moment.tz(date, TIMEZONE).format('Z');
    const dateWithOtherZone = [dateWithoutZone, otherZone].join('');
    return new Date(dateWithOtherZone);
};
const DatePickerWithTimezone = ({ selected, onChange, ...props }) => (React.createElement(ReactDatePicker, { selected: selected ? setLocalZone(selected) : null, onChange: (v, e) => {
        onChange(v ? setRemoteZone(v) : null, e);
    }, ...props }));
export default DatePickerWithTimezone;
